'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Icon.scss.js');
require('../Button/helper.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Icon = function (_a) {
    var variant = _a.variant, disabled = _a.disabled, className = _a.className, fontName = _a.fontName, tabIndex = _a.tabIndex, onClick = _a.onClick, _b = _a.noContent, noContent = _b === void 0 ? false : _b;
    return (React__default['default'].createElement("button", { disabled: disabled, tabIndex: tabIndex, onClick: function (event) { return onClick(event); }, className: index['default']("lp-icon " + (fontName ? "lp-icon--" + fontName : undefined) + " " + (className ? className : undefined), [variant && "lp-icon--" + variant]) }, !noContent && (React__default['default'].createElement("span", null,
        fontName && (React__default['default'].createElement("i", { className: index['default']("lp-icon " + (fontName ? "lp-icon--" + fontName : undefined) + " " + (className ? className : undefined), [variant && "icon--" + variant]) })),
        !fontName && (React__default['default'].createElement("img", { src: "https://lifepal.co.id/static/images/icons/compare.svg", alt: "icon" }))))));
};

exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map
